import { render, staticRenderFns } from "./Plan_Details.vue?vue&type=template&id=577b55e3"
import script from "./Plan_Details.vue?vue&type=script&lang=js"
export * from "./Plan_Details.vue?vue&type=script&lang=js"
import style0 from "./Plan_Details.vue?vue&type=style&index=0&id=577b55e3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports